import React, {useState} from "react";

import { Container } from "../../styles/GlobalStyles";
import { Form, Button } from './styled';
import api from '../../api/axios';
import { CertificateGenerator } from "../../constants/CertificateGenerator";


export default function Solicitacao () {

    const [crdd, setCrdd] = useState('');
    const [cpf, setCpf] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [error, setError] = useState('');
    const [user, setUser] = useState([])
    const [param, setParam] = useState([])

        const getUser = async (document) => {
        var ret
        await api.get('/user/findbydocument/' + document)
            .then(res => {
                setUser(res.data)
                console.log(res.data)
                ret = res.data
            })
            .catch(err => console.log(err))
        return ret
    }

    const getParam = async () => {
        var p
        await api.get('/param/list')
            .then(res => {
                setParam(res.data[0])
                p = res.data[0]
            })
            .catch(err => console.log(err))
        return p
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        var solic = {}
        const submitter = e.nativeEvent.submitter.value; // Botão que foi clicado

/*        if (crdd == '' & cpf == ''){ 
            setError('CRDD ou CPF deve ser preenchido')
            return
        }*/
 //       if (crdd != '' & cpf != ''){ 
        if (cpf == '' & cnpj == ''){
            setError('CPF ou CNPJ deve ser preenchido')
            return
        }
        if (cpf != '' & cnpj != ''){
            setError('Apenas um dos campos deve ser preenchido')
            return
        }

        if (cpf != '') solic = {cpf: cpf}
        else solic = {cnpj: cnpj}
        if (submitter === 'certidao') {
            try {
                var response 
                if (cpf != '')
                    response = await api.post('/certificate/request/', solic);
                else
                    response = await api.post('/certificatecom/request/', solic);
                setError('Solicitação realizada com sucesso!');
                } catch (error) {
                // Trata diferentes tipos de erro aqui
                if (error.response) {
                    console.log(error.response.data.error)
                    setError(error.response.data.error);
                } else if (error.request) {
                    setError("Erro de rede: Servidor não respondeu."); // Servidor fora do ar
                } else {
                    setError('Erro ao configurar a requisição:', error.message); // Erro de sintaxe, etc.
                }
            }
        }
        if (cpf == ''){
            setError('CPF deve ser preenchido para gerar certificado ou baixa')
            return
        }
        var u = await getUser(cpf)
        if (u == null){
            setError('CPF não cadastrado')
            return
        }
        var p = await getParam()
        //setTimeout('', 15000)
//        console.log(u)
//        console.log(p)
        if (submitter === 'certificado') {
            const html = await CertificateGenerator(u, p)
            //console.log(html.toString())
            var newwindows = window.open()
            newwindows.document.write(html)

            setTimeout(function () {
                newwindows.print()
                newwindows.close()
            }, 1000)
        }
//        if (submitter === 'baixa') {
//            console.log('baixa a gerar')
//        }
            //   await api.post('/certificate/request/', solic)
    //        .then(res => {
    //            setError("Solicitação enviada")
    //        })
    //        .catch(err => console.log(err.response))

    }
    return (
        <Container height='400px'>
            <h1>Solicitações do Usuário</h1>
            <Form onSubmit={handleSubmit}>
                {/*<input type="number" value={crdd} 
                    onChange={e => setCrdd(e.target.value)} 
                    placeholder="Informe seu CRDD"
                    onKeyDown={(e) => {
                        if (
                        [
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                        ].includes(e.key)
                        ) {
                            return;
                        }

                        if (!/^\d$/.test(e.key)) {
                            e.preventDefault();
                        } else {
                            if (e.target.value.length > 3)
                                e.preventDefault();
                        }
                    }}
                    onPaste={(e) => {
                        if (!/^\d+$/.test(e.clipboardData.getData("text"))) {
                        e.preventDefault();
                        }
                    }}
                    min={0}
                    max={9999}
                    />*/}
                <input type="text" value={cpf} onChange={e => setCpf(e.target.value)} placeholder="CPF (000.000.000-00)" maxLength={14} minLength={14}/>
                <input type="text" value={cnpj} onChange={e => setCnpj(e.target.value)} placeholder="CNPJ (00.000.000/0000-00)" maxLength={18} minLength={18}/>
                <div className="erro">{error ? error : ''}</div>
                <Button type="submit" value="certidao">Certidão</Button>
                <br></br>
                <Button type="submit" value="certificado">Certificado</Button>
                <br></br>
                {/*<button type="submit" value="baixa" disabled="true">Baixa</button>
                <br></br>*/}
            </Form>
        </Container>
    );
}